<template>
  <div>
    <v-data-table
      class="astra-table"
      dense
      height="76vh"
      fixed-header
      :headers="controller.headers"
      :options.sync="controller.options"
      :server-items-length="controller.equipmentStatusPagination.total"
      :items="controller.equipmentStatusPagination.items"
      :loading="controller.loading"
      :footer-props="{
        'items-per-page-options': [40, 80],
      }"
    >
      <template v-slot:[`item.createdDate`]="{ item }">
        {{ dayjs(item.createdDate).format("DD/MM/YYYY HH:mm") }}
      </template>

      <template v-slot:[`item.updatedDate`]="{ item }">
        {{ dayjs(item.updatedDate).format("DD/MM/YYYY HH:mm") }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          small
          icon
          color="primary"
          @click="controller.viewOnMap(item)"
          v-if="item.latitude && item.longitude"
          title="Ver no mapa"
        >
          <v-icon small>mdi-map-marker</v-icon>
        </v-btn>
        <v-btn
          small
          icon
          color="primary"
          @click="controller.openLogDialog(item)"
          title="Ver logs"
        >
          <v-icon small>mdi-text-box-outline</v-icon>
        </v-btn>
      </template>
         

      <template v-slot:[`item.ignitionStatus`]="{ item }">
        <v-checkbox
          color="primary"
          class="mt-0 pt-0"
          v-model="item.ignitionStatus"
          hide-details
          readonly
          dense
        ></v-checkbox>
      </template>

      <template v-slot:[`item.gpsAntennaStatus`]="{ item }">
        <v-checkbox
          color="primary"
          class="mt-0 pt-0"
          v-model="item.gpsAntennaStatus"
          hide-details
          readonly
          dense
        ></v-checkbox>
      </template>

      <template v-slot:[`item.gpsAntennaStatus`]="{ item }">
        <v-checkbox
          color="primary"
          class="mt-0 pt-0"
          v-model="item.gpsAntennaStatus"
          hide-details
          readonly
          dense
        ></v-checkbox>
      </template>

      <template v-slot:[`item.sensorOneStatus`]="{ item }">
        <v-checkbox
          color="primary"
          class="mt-0 pt-0"
          v-model="item.sensorOneStatus"
          hide-details
          readonly
          dense
        ></v-checkbox>
      </template>

      <template v-slot:[`item.sensorTwoStatus`]="{ item }">
        <v-checkbox
          color="primary"
          class="mt-0 pt-0"
          v-model="item.sensorTwoStatus"
          hide-details
          readonly
          dense
        ></v-checkbox>
      </template>

      <template v-slot:[`item.sensorThreeStatus`]="{ item }">
        <v-checkbox
          color="primary"
          class="mt-0 pt-0"
          v-model="item.sensorThreeStatus"
          hide-details
          readonly
          dense
        ></v-checkbox>
      </template>

      <template v-slot:[`item.sensorFourStatus`]="{ item }">
        <v-checkbox
          color="primary"
          class="mt-0 pt-0"
          v-model="item.sensorFourStatus"
          hide-details
          readonly
          dense
        ></v-checkbox>
      </template>

      <template v-slot:[`item.sensorFiveStatus`]="{ item }">
        <v-checkbox
          color="primary"
          class="mt-0 pt-0"
          v-model="item.sensorFiveStatus"
          hide-details
          readonly
          dense
        ></v-checkbox>
      </template>

      <template v-slot:top>
        <v-row class="pa-3" no-gutters>
          <v-col
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'py-3 d-flex align-center justify-center'
                : 'd-flex align-center'
            "
            cols="12"
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <span class="table-title">Status dos Equipamentos</span>
          </v-col>
          <v-col
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'd-flex flex-column align-center justify-center'
                : 'd-flex align-center justify-end'
            "
            cols="12"
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <v-btn
              small
              outlined
              color="primary"
              @click="controller.openMapDialog()"
              >
              <v-icon left small>mdi-map</v-icon>
              Mostrar Mapa
            </v-btn>
            <v-text-field
              class="pa-2 search-tf"
              style="max-width: 250px"
              outlined
              color="primary"
              hide-details
              dense
              placeholder="Pesquisar equipamento..."
              v-model="controller.search"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <v-dialog
      v-model="controller.logDialog"
      max-width="700px"
      persistent
    >
      <v-card 
        class="crud-card d-flex flex-column"
        style="max-height: 85vh"
      >
        <v-card-title 
          class="log-card-title d-flex flex-wrap justify-space-between align-center"
          style="position: relative"
        >
          <span class="text-h6">Logs do Equipamento: {{ controller.selectedEquipmentStatus }}</span>
          <v-spacer></v-spacer>
          <div class="d-flex align-center mt-2 mt-sm-0">
            <span class="log-count mr-2">
              {{ controller.equipmentStatusLogPagination.total }} log(s)
            </span>
            <v-select
              class="search-tf"
              style="max-width: 150px"
              outlined
              dense
              color="primary"
              v-model="controller.logTypeSelected"
              :items="controller.logTypeList"
              hide-details
              item-text="text"
              item-value="value"
              @change="controller.changeLogType()"
            ></v-select>
          </div>
          <v-progress-linear
            :active="controller.loadingLogs"
            :indeterminate="controller.loadingLogs"
            absolute
            bottom
            color="primary"
          ></v-progress-linear>
        </v-card-title>
        
        <v-data-iterator
          :items="controller.equipmentStatusLogPagination.items"
          :options.sync="controller.equipmentStatusLogOptions"
          :server-items-length="controller.equipmentStatusLogPagination.total"
          :loading="controller.loadingLogs"
           loading-text="" 
          :footer-props="{
            'items-per-page-options': [40, 80]
          }"
          style="flex-grow: 1; display: flex; flex-direction: column; overflow: hidden;"
        >

        <template v-slot:default="{ items }">
          <v-card-text class="pa-0" style="flex-grow: 1; overflow-y: auto;">
            <v-list dense>
              <v-list-item
              v-for="log in items"                  
              :key="log.id"
              class="log-item"
              :class="{
                  'info-log': log.equipmentStatusLogTypeID === 1,
                  'warning-log': log.equipmentStatusLogTypeID === 2,
                  'error-log': log.equipmentStatusLogTypeID === 3
                }"
              >
                <v-list-item-content>
                  <v-list-item-title class="log-title">
                    <v-icon
                      small
                      :class="{
                        'info-icon': log.equipmentStatusLogTypeID === 1,
                        'warning-icon': log.equipmentStatusLogTypeID === 2,
                        'error-icon': log.equipmentStatusLogTypeID === 3
                      }"
                      class="mr-1"
                      >
                      {{ controller.getLogIcon(log.equipmentStatusLogTypeID) }}
                    </v-icon>
                    Componente - {{ log.componentType }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="log-message">
                    Mensagem - {{ log.message }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="log-date">
                    Data do Log - {{ dayjs(log.logDate).format("DD/MM/YYYY HH:mm") }}
                  </v-list-item-subtitle>
                  <!-- <v-list-item-subtitle class="log-date">
                    Data de Criação - {{ dayjs(log.createdDate).format("DD/MM/YYYY HH:mm") }}
                  </v-list-item-subtitle> -->
                </v-list-item-content>
                
                <v-list-item-action v-if="log.latitude && log.longitude">
                  <v-btn
                    small
                    icon
                    color="primary"
                    @click="controller.viewLogOnMap(log)"
                    title="Ver no mapa"
                  >
                    <v-icon small>mdi-map-marker</v-icon>
                  </v-btn>
                </v-list-item-action>
               </v-list-item>
              </v-list>
            </v-card-text>
          </template>
          <template v-slot:no-data>
            <v-card-text class="pa-0">
            <v-row justify="center" align="center" class="ma-4">
              <span>Nenhum log disponível.</span>
            </v-row>
            </v-card-text>
          </template>  
          <template v-slot:footer>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="controller.closeLogDialog()">Fechar</v-btn>
            </v-card-actions>
          </template>
        </v-data-iterator>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="controller.mapDialog"
      max-width="1000"
      persistent
      scrollable
    >
      <v-card class="crud-card">
        <v-card-title>
          <v-spacer></v-spacer>
          <span class="table-title">
            Localizações dos Equipamentos
          </span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            class="close-map-btn"
            @click="controller.closeMapDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-select
                class="search-tf mt-4"
                v-model="controller.selectedEquipment"
                :items="controller.getEquipmentsWithLocation()"
                item-text="equipmentName"
                return-object
                label="Selecionar Equipamento"
                outlined
                dense
                clearable
              />
              <div class="period-group">
                <span class="period-group-title">Período entre logs</span>
                <div class="form-input-group">
                  <date-picker
                    class="search-tf"
                    single-line
                    id="mapStartDate"
                    background-color="transparent"
                    outlined
                    required
                    dense
                    label="Data Inicial"
                    v-model="controller.mapStartDate"
                  ></date-picker>
                  <label for="mapStartDate">Data Inicial</label>
                </div>
                <div class="form-input-group">
                  <date-picker
                    single-line
                    class="search-tf"
                    id="mapEndDate"
                    background-color="transparent"
                    outlined
                    required
                    dense
                    label="Data Final"
                    v-model="controller.mapEndDate"
                  ></date-picker>
                  <label for="mapEndDate">Data Final</label>
                </div>
              </div>
              <div v-if="controller.selectedEquipment">
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <b>Estado:</b> {{ controller.selectedEquipment.equipmentStateName || 'N/A' }}
                      </v-list-item-title>
                      <v-list-item-title>
                        <b>Última Atualização:</b> {{ dayjs(controller.selectedEquipment.updatedDate).format("DD/MM/YYYY HH:mm") }}
                      </v-list-item-title>
                      <v-list-item-title>
                        <b>Latitude: </b> {{ controller.selectedEquipment.latitude }}
                      </v-list-item-title>
                      <v-list-item-title>
                        <b>Longitude: </b> {{ controller.selectedEquipment.longitude }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-col>
            <v-col cols="12" md="8">
              <leaflet-map
                v-if="controller.mapDialog"
                ref="leafletMap"
                :markers="controller.getMapMarkers()"
                :height="'60vh'"
                :center="controller.getMapCenter()"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { equipmentStatusController } from "@/di/di";
import dayjs from "dayjs";
import LeafletMap from "@/core/component/leaflet_map.vue";

export default {
  name: "equipmentStatusPage",
  components: {
    LeafletMap
  },
  computed: {
    dayjs() {
      return dayjs
    }
  },
  data: (context) => ({
    controller: equipmentStatusController(context),
  }),
  watch: {
  "controller.options"() {
    this.controller.watchOptions();
  },
  "controller.search"() {
    this.controller.watchSearch();
  },
  "controller.equipmentStatusLogOptions"() {
    this.controller.watchEquipmentStatusLogOptions()
  },
  "controller.searchEquipmentStatusLog"() {
    this.controller.watchSearchEquipmentStatusLog()
  },
  "controller.mapDialog"(isOpen) {
    this.controller.watchMapDialog(isOpen);
  },
  'controller.selectedEquipment'(equipmentSelected, currentEquipment) {
    this.controller.watchSelectedEquipment(equipmentSelected, currentEquipment);
  },
  "controller.mapStartDate"() {
    this.controller.watchMapStartDate();
  },
  "controller.mapEndDate"() {
    this.controller.watchMapEndDate();
  }
  },
  mounted() {
    this.controller.paginate();
  },
};
</script>

<style scoped lang="scss">
.astra-table {
  border-radius: 20px;
  background-color: var(--v-secondary-base) !important;
}

.toolbar-table {
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
}

::v-deep .v-data-table.v-data-table--fixed-header thead th {
  background-color: var(--v-secondary-base) !important;
}

.action-btn {
  text-transform: none;
  border-radius: 10px !important;
}

.close-map-btn {
  position: absolute;
  align-items: center;
  top: 12px;
  right: 12px;
  z-index: 2;
}

.v-card-title {
  position: relative;
  min-height: 56px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-right: 48px;
}

.search-tf {
  border-radius: 10px !important;
}

.table-title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 20px;
  text-align: center;
  max-width: calc(100% - 48px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.crud-card {
  border-radius: 20px;
  background-color: var(--v-secondary-base) !important;
}

::v-deep .v-dialog {
  border-radius: 20px !important;
}

label {
  order: -1;
}

.v-input:focus-within + label {
  color: var(--v-primary-base) !important;
}

.form-input-group {
  display: flex;
  flex-direction: column;
}

.log-card {
  border-radius: 10px;
  max-width: 350px;
  max-height: 300px;
  background-color: var(--v-secondary-base) !important;
  display: flex;
  flex-direction: column;

  @media (max-width: 500px) {
    max-width: 270px;
  }
}

@media (max-width: 600px) {
  .log-card-title {
    justify-content: center !important;
    text-align: center;

    .v-spacer {
      display: none;
    }

    .text-h6 {
      width: 100%;
      margin-bottom: 8px;
    }
  }
}

.log-card-title {
  font-size: 16px;
  padding: 10px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
}

.log-card-content {
  overflow-y: auto;
}

.log-count {
  font-size: 12px;
}

.log-item {
  border-left: 3px solid transparent;
  margin-bottom: 4px;
  border-radius: 0 4px 4px 0;
  position: relative;
}

.info-log {
  border-left-color: #2196F3;
  background-color: rgba(33, 150, 243, 0.05);
}

.warning-log {
  border-left-color: #FFC107;
  background-color: rgba(255, 193, 7, 0.05);
}

.error-log {
  border-left-color: #F44336;
  background-color: rgba(244, 67, 54, 0.05);
}

.info-icon {
  color: #2196F3 !important;
}

.warning-icon {
  color: #FFC107 !important;
}

.error-icon {
  color: #F44336 !important;
}

.log-title {
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  white-space: normal;
}

.log-message {
  font-size: 12px;
  padding-left: 24px;
  white-space: normal;
}

.log-date {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.6);
  padding-left: 24px;
  margin-top: 4px;
  white-space: normal;
}

.log-content-area {
  max-height: 70vh;
  overflow-y: auto;
}

.period-group {
  border: 1px solid;
  border-radius: 10px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 16px;
  margin-top: 10px;
  margin-bottom: 10px;
  position: relative;
}

.period-group-title {
  position: absolute;
  top: -10px;
  left: 8px;
  background: var(--v-secondary-base);
  padding: 0 4px;
  font-size: 12px;
}

::v-deep tbody {
  tr:hover {
    background-color: var(--v-tertiary-base) !important;
  }
}
</style>